import React, { useEffect } from "react";
import { Redirect } from "expo-router";

import { useSession } from "@/context/auth/useSession";
import LandingScreen from "@/screens/LandingScreen";
import LoadingScreen from "@/screens/Loading/LoadingScreen";
import { configureSentryUser } from "@/utils/sentry";
import { configureAnalyticsUser } from "@/utils/analytics";

export default function Layout(): React.JSX.Element {
  const { isSessionLoading, session } = useSession();

  useEffect(() => {
    if (session?.identity.username) {
      configureSentryUser(session.identity.username);
      configureAnalyticsUser(session.identity.username);
    }
  }, [session?.identity.username]);

  // Determine which screen to show
  const renderScreen = (): React.JSX.Element => {
    // Priority 1: Show loading screen if still loading session or checking for updates
    if (isSessionLoading) {
      return <LoadingScreen />;
    }

    // Priority 2: If user is logged in, redirect to main screen, where onboarding is handled
    if (session !== null) {
      return <Redirect href="/(main)/explore/home" />;
    }

    // Priority 3: Default to landing screen if not logged in
    return <LandingScreen />;
  };

  return renderScreen();
}
